"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const react_router_dom_1 = require("react-router-dom");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const ChevronLeftRounded_1 = __importDefault(require("@mui/icons-material/ChevronLeftRounded"));
const ChevronRightRounded_1 = __importDefault(require("@mui/icons-material/ChevronRightRounded"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ClearRounded_1 = __importDefault(require("@mui/icons-material/ClearRounded"));
const Stop_1 = __importDefault(require("@mui/icons-material/Stop")); // Do not use rounded version for this one
const SettingsRounded_1 = __importDefault(require("@mui/icons-material/SettingsRounded"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const accounts_1 = require("companion-app-components/flux/accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const DownshiftField_1 = __importDefault(require("components/QuickenControls/DownshiftField"));
const QMenu_1 = __importDefault(require("components/QMenu"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const themeUtils_1 = require("themes/themeUtils");
const styles_1 = require("../../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.calTopHeaderStyles);
const monthsData = luxon_1.Info.months().map((month, index) => ({
    key: month, label: month, index: index + 1,
}));
const prevYears = 10;
const nextYears = 5;
const prevYearsArray = [...Array(prevYears).keys()].map((i) => luxon_1.DateTime.local().year - (i + 1)).reverse();
const nextYearsArray = [...Array(nextYears).keys()].map((i) => luxon_1.DateTime.local().year + (i + 1));
const yearsData = [...prevYearsArray, luxon_1.DateTime.local().year, ...nextYearsArray]
    .map((year) => ({ key: `${year}`, label: `${year}`, value: year }));
const qMenuAnchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};
const qMenuTransformOrigin = {
    vertical: 'top',
    horizontal: 'right',
};
const CalTopHeader = (props) => {
    var _a, _b, _c;
    const { classes, cx } = useStyles();
    const { updateDateState, onPrefsOpen, onAccountsPrefsModalOpen, showCloseButton, onClose, curMonth } = props;
    const { date } = curMonth !== null && curMonth !== void 0 ? curMonth : { date: null };
    const closeAndExit = (0, react_1.useCallback)(() => onClose && onClose(), [onClose]);
    const iconColor = (0, themeUtils_1.applyOpacityToHex)('#000000', 0.8);
    const location = (0, react_router_dom_1.useLocation)();
    const showAllAccounts = (_a = location.search) === null || _a === void 0 ? void 0 : _a.includes('displayNode=all');
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const accountsByIdData = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const originalAccountsToShow = (0, react_1.useMemo)(() => datasetPreferences.calendarTransaction.accountsToShow, [datasetPreferences]) || (0, immutable_1.List)();
    const accountsById = (0, react_1.useMemo)(() => accountsByIdData && accountsByIdData.filterNot((account) => (account.type === 'INVESTMENT')), [accountsByIdData]);
    const qMenuOptions = (0, react_1.useMemo)(() => [{ label: 'Preferences', value: 'preferences' }, ...(showAllAccounts && !isEntitySharedUser) ? [{ label: 'Calendar Accounts', value: 'accounts' }] : []], [showAllAccounts, isEntitySharedUser]);
    const showAccountPrefReset = (0, react_1.useMemo)(() => {
        if (originalAccountsToShow.size !== accountsById.size)
            return true;
        if (originalAccountsToShow.size && originalAccountsToShow.every((acc) => !accountsById.has(acc)))
            return true;
        return false;
    }, [originalAccountsToShow, accountsById]);
    const onNextMonth = (0, react_1.useCallback)(() => {
        updateDateState(date === null || date === void 0 ? void 0 : date.plus({ months: 1 }), 'next-month');
    }, [updateDateState, date]);
    const onPrevMonth = (0, react_1.useCallback)(() => {
        updateDateState(date === null || date === void 0 ? void 0 : date.minus({ months: 1 }), 'previous-month');
    }, [updateDateState, date]);
    const onCurrentMonth = (0, react_1.useCallback)(() => {
        updateDateState(luxon_1.DateTime.local(), 'current-month');
    }, [updateDateState]);
    const onCustomMonth = (0, react_1.useCallback)((monthData) => {
        updateDateState(luxon_1.DateTime.local(date.year, monthData.index), 'month-picker');
    }, [updateDateState, date]);
    const onCustomYear = (0, react_1.useCallback)((yearData) => {
        updateDateState(luxon_1.DateTime.local(yearData.value, date.month), 'year-picker');
    }, [updateDateState, date]);
    const labelFromItem = (0, react_1.useCallback)((item) => item === null || item === void 0 ? void 0 : item.label, []);
    const keyFromItem = (0, react_1.useCallback)((item) => item === null || item === void 0 ? void 0 : item.key, []);
    const onQMenuChange = (0, react_1.useCallback)((value) => {
        if (value === 'preferences') {
            onPrefsOpen();
        }
        else if (value === 'accounts') {
            onAccountsPrefsModalOpen();
        }
    }, [onPrefsOpen, onAccountsPrefsModalOpen]);
    const monthSelectedIndex = ((_b = date === null || date === void 0 ? void 0 : date.month) !== null && _b !== void 0 ? _b : 0) - 1;
    const yearSelectedIndex = yearsData.findIndex((y) => y.value === (date === null || date === void 0 ? void 0 : date.year));
    const textFieldProps = (0, react_1.useMemo)(() => ({
        InputProps: {
            disableUnderline: true,
            classes: {
                input: classes.inputRoot,
            },
        },
        fullWidth: true,
    }), [classes]);
    const disablePrevBtn = (0, react_1.useMemo)(() => {
        var _a;
        const firstYear = yearsData && luxon_1.DateTime.local((_a = yearsData[0]) === null || _a === void 0 ? void 0 : _a.value).minus({ months: 1 }).toISODate();
        return firstYear === (date === null || date === void 0 ? void 0 : date.minus({ months: 1 }).toISODate());
    }, [date]);
    const disableNextBtn = (0, react_1.useMemo)(() => {
        var _a;
        const lastYear = yearsData && luxon_1.DateTime.local((_a = yearsData[yearsData.length - 1]) === null || _a === void 0 ? void 0 : _a.value, 12).plus({ months: 1 }).toISODate();
        return lastYear === (date === null || date === void 0 ? void 0 : date.plus({ months: 1 }).toISODate());
    }, [date]);
    const onResetHandler = (0, react_1.useCallback)(() => {
        setDatasetPreference({ calendarTransaction: { accountsToShow: accountsById.map((acc) => acc.id).toSet() } });
    }, [accountsById, setDatasetPreference]);
    return (<header className={classes.monthHeader}>
      <div className={classes.controlGroup}>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-prev-month" className={cx(classes.iconControl, { [classes.iconControlDisabled]: disablePrevBtn })} onClick={onPrevMonth} disabled={disablePrevBtn}>
            <ChevronLeftRounded_1.default />
          </ButtonBase_1.default>
        </div>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-current-month" className={classes.iconControl} onClick={onCurrentMonth}>
            <Stop_1.default className={classes.iconToday}/>
          </ButtonBase_1.default>
        </div>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-next-month" className={cx(classes.iconControl, { [classes.iconControlDisabled]: disableNextBtn })} onClick={onNextMonth} disabled={disableNextBtn}>
            <ChevronRightRounded_1.default />
          </ButtonBase_1.default>
        </div>

        {date && (<>
            <div className={cx(classes.controlRoot, classes.monthPickerRoot)}>
              <DownshiftField_1.default key={`month-${date.month}`} items={monthsData} initialItemSelected={monthsData[monthSelectedIndex]} initialInputValue={monthsData[monthSelectedIndex].label} itemToString={labelFromItem} itemKey={keyFromItem} autoFocus={false} onSelected={onCustomMonth} textFieldProps={textFieldProps}/>
            </div>

            <div className={cx(classes.controlRoot, classes.yearPickerRoot)}>
              <DownshiftField_1.default key={`year-${date.year}`} items={yearsData} initialItemSelected={yearsData[yearSelectedIndex]} initialInputValue={(_c = yearsData[yearSelectedIndex]) === null || _c === void 0 ? void 0 : _c.label} itemToString={labelFromItem} itemKey={keyFromItem} autoFocus={false} onSelected={onCustomYear} textFieldProps={textFieldProps}/>
            </div>
          </>)}
      </div>

      <div className={classes.settingsRoot}>
        {showAllAccounts && showAccountPrefReset && !isEntitySharedUser &&
            <Button_1.default id="reset-button" variant="contained" onClick={onResetHandler} classes={{ root: classes.button }}>
            Reset To Default
          </Button_1.default>}
        <QMenu_1.default customTrigger={<SettingsRounded_1.default className={classes.settingsIcon}/>} name={'qmenu-calendar-settings'} menuIconButtonSize="medium" customTriggerClass={classes.settingsIconRoot} options={qMenuOptions} anchorOrigin={qMenuAnchorOrigin} transformOrigin={qMenuTransformOrigin} onChange={onQMenuChange}/>
        {showCloseButton &&
            <IconButton_1.default style={{ color: iconColor }} aria-label="Close" id="dlg-close" type="button" onClick={closeAndExit}>
          <ClearRounded_1.default />
        </IconButton_1.default>}
      </div>
    </header>);
};
exports.default = react_1.default.memo(CalTopHeader);
